module.exports.AlbumSelected = /* @ngInject */ function AlbumSelected($rootScope, MixpanelEventsListener) {
    return function (orig, album) {

        let data = {
            origin: orig,
            albumName: album.name,
            albumCode: album.code,
            labelName: album.label.name,
            labelGroupName: album.label.labelGroup.name,
        };

        $rootScope.$emit(MixpanelEventsListener.ALBUM_CLICK, data);
    };
};


// WEBPACK FOOTER //
// ./src/PlayApp/AppBundle/Resources/js/angular/services/AlbumSelected.js